import { FileSystemEntry } from './dom.types';

/**
 * FileEntry is an instance of {@link FileSystemFileEntry} or {@link FileSystemDirectoryEntry}.
 * Which one is it can be checked using {@link FileSystemEntry.isFile} or {@link FileSystemEntry.isDirectory}
 * properties of the given {@link FileSystemEntry}.
 *
 * This class uses a custom {@link FileSystemEntry} rather than the default typescript one.
 * Done this way so that a fake {@link FileSystemFileEntry} can be created when a file is selected via the window rather than by dropping it.
 *
 * We should be able to do without this by migrating to the new file API.
 */
export class FileDropEntry {
  constructor(
    public relativePath: string,
    public fileEntry: FileSystemEntry
  ) {}
}
